
import css from './BlogPageSkeleton.module.css';

const BlogPageSkeleton = ({ count }) => {
  return (
    <div className={css.blog}>
      {Array.from({ length: count }).map((_, index) => (
        <div className={css.card} key={index}>
          <div className={css.imageWrapper}>
            <div className={css.imageSkeleton} />
          </div>
          <div className={css.titleSkeleton1} />
        </div>
      ))}
    </div>
  );
};

const BlogDetailSkeleton = () => {
  return (
    <div className={css.outerWrapper}>
      <div className={css.container}>
        <div className={`${css.titleSkeleton} ${css.skeleton}`} />
        <div className={`${css.textSkeleton} ${css.skeleton}`} />
        <div className={css.img}>
          <div className={`${css.imageSkeleton} ${css.skeleton}`} />
        </div>
        <div className={`${css.authorSkeleton} ${css.skeleton}`} />
        <div className={`${css.contentSkeleton} ${css.skeleton}`}/>
      </div>
    </div>
  );
};



export { BlogPageSkeleton, BlogDetailSkeleton };

